import { render } from "./NewCarLoanCalculatorResult.vue?vue&type=template&id=2fbf565e"
import script from "./NewCarLoanCalculatorResult.vue?vue&type=script&lang=js"
export * from "./NewCarLoanCalculatorResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__